var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCategories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14286 10.2857H1.14286C0.512381 10.2857 0 9.77333 0 9.14286V1.14286C0 0.512381 0.512381 0 1.14286 0H9.14286C9.77333 0 10.2857 0.512381 10.2857 1.14286V9.14286C10.2857 9.77333 9.77333 10.2857 9.14286 10.2857ZM24 22.8571V14.8571C24 14.2267 23.4876 13.7143 22.8571 13.7143H14.8571C14.2267 13.7143 13.7143 14.2267 13.7143 14.8571V22.8571C13.7143 23.4876 14.2267 24 14.8571 24H22.8571C23.4876 24 24 23.4876 24 22.8571ZM5.14286 13.7143C2.30286 13.7143 0 16.0171 0 18.8571C0 21.6971 2.30286 24 5.14286 24C7.98286 24 10.2857 21.6971 10.2857 18.8571C10.2857 16.0171 7.98286 13.7143 5.14286 13.7143ZM18.8571 0C16.0171 0 13.7143 2.30286 13.7143 5.14286C13.7143 7.98286 16.0171 10.2857 18.8571 10.2857C21.6971 10.2857 24 7.98286 24 5.14286C24 2.30286 21.6971 0 18.8571 0Z",
    fill: "#00C8D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategories);
export default __webpack_public_path__ + "static/media/IconCategories.eccfac33c4ee9b69692938d6237a9be6.svg";
export { ForwardRef as ReactComponent };